<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.commission_log")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker(@update="submit")
              CheckDownline.col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(
                ref="username"
                :loading="loading"
                @keyup.enter.native="submit"
                @updateValue="updateTargetId($event)"
              )
              //- CheckDownline.col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(
              //-   ref="action_by"
              //-   text="action_by"
              //-   :loading="loading"
              //-   @keyup.enter.native="submit"
              //-   @updateValue="updateActionBy($event)"
              //- )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.ip_address')" size="sm")
                  b-form-input(
                    type="text"
                    ref="ip_address"
                    v-model="ip_address"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.target_action')" size="sm")
                  b-form-select(
                    size="sm"
                    ref="target_action"
                    v-model="target_action"
                    @change="submit"
                  )
                    option(value="") {{ $t("ui.all") }}
                    option(value="update_commission_sb") {{ $t("ui.sportsbook") }}
                    option(value="update_commission_sl") {{ $t("ui.slots") }}
                    option(value="update_commission_lc") {{ $t("ui.live_casino") }}
                    option(value="update_commission_lo") {{ $t("ui.lotto") }}
                    option(value="update_commission_kn") {{ $t("ui.keno") }}
                    option(value="update_commission_cf") {{ $t("ui.esports2") }}
                    option(value="update_commission_lt") {{ $t("ui.lottery") }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
                TableToCSV(v-if="totalRows")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="accesslogList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(datetime)="row")
                    span {{ $moment(row.item.datetime).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(errorTag)="row")
                    span(:class="row.item.success ? 'text-primary': 'text-danger'") {{ row.item.errorTag.toUpperCase() }}
                  template(v-slot:cell(ipAddress)="row")
                    span {{ row.item.ipAddress }}
                  template(v-slot:cell(targetId)="row")
                    span {{ row.item.targetId.toUpperCase() }}
                  template(v-slot:cell(actionBy)="row")
                    span {{ row.item.actionBy.toUpperCase() }}
                  template(v-slot:cell(targetAction)="row")
                    span {{ $t('ui.' + row.item.targetAction) }}
                  template(v-slot:cell(details)="row")
                    template(v-if="row.item.success && row.item.details")
                      template(v-if="!['update_commission_sb','update_commission_lt'].includes(row.item.details[0].key)")
                        span {{ row.item.details[0].value + "%" }}
                      template(v-else)
                        i.fa(size="sm" @click.stop="row.toggleDetails" @click="showDetail(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  template(v-slot:row-details="row")
                    b-table#innerTable.table-sm.table-bordered(show-empty :items="row.item.details" :fields="vDfields")
                      template(v-slot:cell(value)="row")
                        template(v-if="row.item.key == 'update_commission_sb'")
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.combine.comm_limit_A") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.combine.comm_limit_B") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.combine.comm_limit_C") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.combine.comm_limit_D") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.combine.comm_limit_E") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.combine.comm_limit_F") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.oxt") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.others") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.hdp_packages") }}
                            tbody
                              tr
                                td.text-center {{ row.item.value.hdp_a + "%" }}
                                td.text-center {{ row.item.value.hdp_b + "%" }}
                                td.text-center {{ row.item.value.hdp_c + "%" }}
                                td.text-center {{ row.item.value.hdp_d + "%" }}
                                td.text-center {{ row.item.value.hdp_e + "%" }}
                                td.text-center {{ row.item.value.hdp_f + "%" }}
                                td.text-center {{ row.item.value.one_x_two + "%" }}
                                td.text-center {{ row.item.value.others + "%" }}
                                td.text-center {{ row.item.value.hdp_packages }}
                        template(v-else)
                          table.table.table-bordered
                            thead
                              tr
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.lottery_1d") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.lottery_2d") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.lottery_3d") }}
                                th.text-center.align-middle.text-white.bg-dark-lighter {{ $t("ui.lottery_4d") }}
                            tbody
                              tr
                                td.text-center {{ row.item.value.one_d + "%" }}
                                td.text-center {{ row.item.value.two_d + "%" }}
                                td.text-center {{ row.item.value.three_d + "%" }}
                                td.text-center {{ row.item.value.four_d + "%" }}
</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton.vue"
import CheckDownline from "@/library/CheckDownline.vue"
import TableToCSV from "@/library/TableToCSV.vue"
import DatePicker from "@/library/DatePicker.vue"

export default {
  components: {
    SubmitButton,
    CheckDownline,
    TableToCSV,
    DatePicker
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      ip_address: "",
      // action_by: "",
      target_id: "",
      target_action: "",
      accesslogList: [],
      filter: null,
      sortBy: "datetime",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format(
          "YYYY-MM-DD"
        )
      };
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "datetime",
          label: this.$t("ui.date_time"),
          sortable: false,
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "errorTag",
          label: this.$t("ui.status"),
          thClass: "bg-grey",
          thStyle: {
            width: "11%"
          }
        },
        {
          key: "ipAddress",
          label: this.$t("ui.ip_address"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "targetId",
          label: this.$t("ui.username"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "actionBy",
          label: this.$t("ui.action_by"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "targetAction",
          label: this.$t("ui.target_action"),
          sortable: false,
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "details",
          label: this.$t("ui.details"),
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        }
      ];
    },
    vDfields() {
      return [
        {
          key: "value",
          label: this.$t("ui.value"),
          thClass: "d-none",
          thStyle: {
            width: "80%"
          }
        }
      ];
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    dayList: function() {
      let result = []
      result = list.Table[0]
      return result
    }
  },
  mounted: function() {},
  methods: {
    updateTargetId(e) {
      this.target_id = e
    },
    // updateActionBy(e) {
    //   this.action_by = e
    // },
    showDetail: function(item) {
      if(item._showDetails) {
        this.accesslogList.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    submit: function() {
      this.$refs.username.$v.$touch()
      if (!this.$refs.username.$v.$invalid) {
        let url = config.commissionLogUrl()
        let ipAddress = this.ip_address
        let actionBy = "" //this.action_by.toLowerCase()
        let targetId = this.target_id //(this.target_id !== '') ? this.target_id.toLowerCase() : this.$store.getters.loginID.toLowerCase()
        let targetAction = this.target_action
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sortkey = this.sortBy
        let sorttype = this.direction
        this.loading = true
        this.$store
          .dispatch("log/getLog", {
            url,
            ipAddress,
            actionBy,
            targetId,
            targetAction,
            start_date,
            end_date,
            page_number,
            page_size,
            sortkey,
            sorttype
          })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.status
            if (this.submission.success == true) {
              this.totalRows = response.value[response.value.length - 1].results[0].filteredCount
              response.value.pop()
              this.accesslogList = response.value
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.status
            }
          })
          .catch(response => {
            this.loading = false
            this.totalRows = 0
            this.accesslogList = []
          });
      }
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    }
  }
};
</script>
